import { useState } from "react";

import { useApiClient } from "../../api-client";

interface RequestVirtualCard {
  mobileCountryCode: string;
  mobilePhone: string;
  birthdate: string;
}

const useRequestVirtualCard = () => {
  const [isLoadingVirtualCard, setIsLoadingVirtualCard] = useState(false);
  const { post } = useApiClient();

  const requestVirtualCard = async ({
    mobileCountryCode,
    mobilePhone,
    birthdate,
  }: RequestVirtualCard) => {
    setIsLoadingVirtualCard(true);
    await post("/v2/employees/card/virtual", {
      mobileCountryCode: mobileCountryCode,
      mobilePhone: mobilePhone,
      birthdate: birthdate,
    });
    setIsLoadingVirtualCard(false);
  };

  return {
    requestVirtualCard,
    isLoadingVirtualCard,
  };
};

export { useRequestVirtualCard };
